interface RtkErrorShape {
  data?: { message?: string; error?: string };
  error?: string;
  status?: number | string;
}

export function extractError(error: unknown, fallback = 'Error desconocido'): string {
  if (!error || typeof error !== 'object') {
    return fallback;
  }
  const err = error as RtkErrorShape;
  if (typeof err.data?.message === 'string') {
    return err.data.message.slice(0, 256);
  }
  if (typeof err.data?.error === 'string') {
    return err.data.error.slice(0, 256);
  }
  if (typeof err.error === 'string') {
    return err.error.slice(0, 256);
  }
  return fallback;
}
